<ds-dialog [isCustomBody]="true" width="100%" [limitDialogHeight]="false">
  <ng-container dsDialogBody>
    @if (type.includes('image')) {
      <img class="image" [src]="url" alt="" />
    }
    @if (type.includes('video')) {
      <video class="video" [src]="url" autoplay="true" controls></video>
    }
  </ng-container>
</ds-dialog>
